$(document).on('click', '[data-tab]', function (ev) {
  ev.preventDefault();
  ev.stopPropagation();

  var $this = $(this);
  var $target = $($this.attr('data-tab'));
  $target.parent().children('.in').removeClass('in tab--active');
  $target.addClass('in tab--active');

  $this.parent().find('.active').removeClass('active');
  $this.find('a').addClass('active');
});